import { INITIAL_STATE } from './state';
import { AnalyticsActions, } from './types';
export const reducer = (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case AnalyticsActions.GET_ANALYTICS:
            return getAnalytics(state, payload);
        case AnalyticsActions.GET_ANALYTICS_HEADER:
            return getAnalyticsOverview(state, payload);
        case AnalyticsActions.SET_ANALYTICS_FILTER:
            return setAnalyticsFilter(state, payload);
        case AnalyticsActions.SET_ANALYTICS_DATE_PERIOD:
            return setAnalyticsDatePeriod(state, payload);
        default:
            return state;
    }
};
function getAnalytics(state, payload) {
    return {
        ...state,
        ...payload,
    };
}
function getAnalyticsOverview(state, payload) {
    return {
        ...state,
        overview: payload,
    };
}
function setAnalyticsFilter(state, payload) {
    return {
        ...state,
        filter: payload,
    };
}
function setAnalyticsDatePeriod(state, payload) {
    return {
        ...state,
        datePeriod: payload,
    };
}
